import React from 'react';
import Banar from '../Banar/Banar';
import Cars from '../Cars/Cars';
import SectionOne from '../SectionOne/SectionOne';
import SectionTwo from '../SectionTwo/SectionTwo';



const Home = () => {
     return (
          <div>
               <Banar></Banar>
               <SectionTwo></SectionTwo>
               <Cars></Cars>
               <SectionOne></SectionOne>
          </div>
     );
};

export default Home;